const PropTypes = require('prop-types');
/* eslint max-len: "off" */

const React = require('react');
const classNames = require('classnames');
const ProductSuggestion = require('components/dashboard/messages/product_suggestion.jsx');
const ProductPreview = require('components/product_search_form/product.jsx');
const Photos = require('components/photos/photos.jsx');
const UrlHelpers = require('components/shared/url_helpers.js');
const APIRequest = require('components/api_request.js');
const TextareaAutosize = require('react-autosize-textarea').default;
const { compact, uniq } = require('lodash');

const URLS_REGEX = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/gi;

class BodyInput extends React.Component {
  constructor() {
    super();

    this.state = {
      isFocused: false,
      productSuggestionOpen: false,
      photosOpen: false,
      message: '',
      loadedProducts: [],
      embeddedProductIds: [],
    };

    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleOpenPhotos = this.handleOpenPhotos.bind(this);
    this.handleToggleProductSuggestion = this.handleToggleProductSuggestion.bind(this);
    this.handleProductSelected = this.handleProductSelected.bind(this);
  }

  get showProductSuggest() {
    return this.props.isSeller && !this.props.hideListingSearch;
  }

  get loadedProductIds() {
    return this.state.loadedProducts.map(product => product.id.toString());
  }

  get embeddedLoadedProducts() {
    // return in the same order as this.state.embeddedProductIds
    const products = this.state.embeddedProductIds.map(id =>
      this.loadedProductById(id));

    return compact(products);
  }

  handleFocus() {
    this.setState({ isFocused: true });
  }

  handleBlur() {
    this.setState({ isFocused: false });
  }

  handleChange(e) {
    this.setState({ message: e.target.value });
    this.parseProductEmbeds(e.target.value);
  }

  handleOpenPhotos(e) {
    e.preventDefault();
    this.setState({ photosOpen: true });
  }

  handleToggleProductSuggestion(e) {
    e.preventDefault();
    this.setState({
      productSuggestionOpen: !this.state.productSuggestionOpen,
    });
  }

  handleProductSelected(product) {
    const link = product._links.web.href;
    const updatedMessage = this.appendLink(link);

    this.setState({
      message: updatedMessage,
      productSuggestionOpen: false,
      loadedProducts: this.state.loadedProducts.concat([product]),
      embeddedProductIds: this.state.embeddedProductIds.concat([product.id]),
    });

    if (this.textarea) { this.textarea.focus(); }
  }

  appendLink(link) {
    const { message } = this.state;

    // separate by 2 newlines, unless there is nothing typed yet
    if (message.length === 0) {
      return link;
    } else if (/\n\n$/.test(message)) {
      return message + link;
    } else if (/\n$/.test(message)) {
      return `${message}\n${link}`;
    }
    return `${message}\n\n${link}`;
  }

  parseProductEmbeds(message) {
    const links = message.match(URLS_REGEX) || [];
    const regex = new RegExp(`${this.props.hostURL}\\/item\\/(\\d+)`);
    let productIds = [];

    links.forEach((link) => {
      const match = link.match(regex);
      if (match) {
        productIds.push(match[1]);
      }
    });

    productIds = uniq(productIds);

    this.setState({ embeddedProductIds: productIds });
    this.loadProducts(productIds);
  }

  loadProducts(ids) {
    ids.forEach((id) => {
      if (!this.hasLoadedProduct(id)) {
        this.loadProduct(id);
      }
    });
  }

  loadProduct(id) {
    APIRequest.V3.get(UrlHelpers.listingPath(id)).then((response) => {
      this.setState({
        loadedProducts: this.state.loadedProducts.concat([response]),
      });
    });
  }

  hasLoadedProduct(id) {
    return this.loadedProductIds.includes(id.toString());
  }

  loadedProductById(id) {
    return this.state.loadedProducts.find(product =>
      product.id.toString() === id.toString());
  }

  inputName(field) {
    return `${this.props.inputNamespace}[${field}]`;
  }

  renderProductSuggestionToggle() {
    if (!this.showProductSuggest) { return null; }
    const classes = classNames('message-attach-listings__link', {
      'icon-r-angle-up': this.state.productSuggestionOpen,
      'icon-r-angle-down': !this.state.productSuggestionOpen,
    });

    return (
      <a
        href="#"
        className={classes}
        onClick={this.handleToggleProductSuggestion}
      >
        {I18n.t('js.conversations.form.attach_listings')}
      </a>
    );
  }

  renderProductSuggestion() {
    if (!this.showProductSuggest || !this.state.productSuggestionOpen) { return null; }

    return (
      <ProductSuggestion
        currentListingIds={compact([this.props.productId])}
        messageFormSelector="[data-message-body]"
        linkSelector="[data-product-suggestion-link]"
        analyticsSource={this.props.analyticsSource}
        onProductSelected={this.handleProductSelected}
      />
    );
  }

  renderAttachImageLink() {
    if (!this.props.allowPhotos) { return null; }

    const classes = classNames('message-attach-images', { disabled: this.state.photosOpen });

    return (
      <a
        href="#"
        onClick={this.handleOpenPhotos}
        className={classes}
      >
        {I18n.t('js.conversations.form.attach_images')}
      </a>
    );
  }

  renderTextarea() {
    return (
      <TextareaAutosize
        name={this.inputName(this.props.bodyInputName)}
        value={this.state.message}
        onChange={this.handleChange}
        ref="textarea"
        rows={3}
        className={classNames('text mb-0 wide', { required: this.props.isRequired })}
        placeholder={I18n.t('js.conversations.form.body.placeholder')}
        autoFocus
        data-detector="input"
        data-message-body
        innerRef={(ref) => { this.textarea = ref; }}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
      />
    );
  }

  renderProductEmbeds() {
    return this.embeddedLoadedProducts.map(product => (
      <div
        className="message-form__listing-preview"
        key={product.id}
      >
        <ProductPreview product={product} />
      </div>
    ));
  }

  renderPhotoUpload() {
    if (!this.state.photosOpen) { return null; }

    return (
      <Photos
        inputName={this.inputName('photos')}
        uploadOptions={this.props.photoUploadOptions}
        requireMinimumDimensions={false}
        allowEdit={false}
        renderTip={false}
      />
    );
  }

  renderAttachments() {
    if (!this.state.photosOpen &&
      this.embeddedLoadedProducts.length === 0) { return null; }

    return (
      <div className="message-form__contents__attachments">
        {this.renderPhotoUpload()}
        {this.renderProductEmbeds()}
      </div>
    );
  }

  renderContents() {
    const classes = classNames('message-form__contents', {
      'message-form__contents--focused': this.state.isFocused,
    });

    return (
      <div
        className={classes}
      >
        {this.renderTextarea()}
        {this.renderAttachments()}
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderContents()}
        <div className="mb-1">
          {this.renderProductSuggestionToggle()}
          {this.renderAttachImageLink()}
        </div>
        {this.renderProductSuggestion()}
      </div>
    );
  }
}

BodyInput.propTypes = {
  inputNamespace: PropTypes.string.isRequired,
  bodyInputName: PropTypes.string,
  hostURL: PropTypes.string.isRequired,
  productId: PropTypes.number.isRequired,
  isSeller: PropTypes.bool.isRequired,
  analyticsSource: PropTypes.string.isRequired,
  photoUploadOptions: PropTypes.object,
  allowPhotos: PropTypes.bool,
  isRequired: PropTypes.bool,
  hideListingSearch: PropTypes.bool,
};

BodyInput.defaultProps = {
  bodyInputName: 'body',
  allowPhotos: true,
  isRequired: true,
  photoUploadOptions: {},
  hideListingSearch: false,
};

module.exports = BodyInput;



// WEBPACK FOOTER //
// ./javascripts/components/conversations/body_input.jsx